/**
 * จำว่าเด็กเปิดกระดาษทดไว้ไหม — **แยกรายวิชา** (CK สั่ง 24 ก.ย. 2569)
 *
 * ★ ทำไมต้องแยกรายวิชา: "บางวิชาไม่ได้ใช้กระดาษทด เวลาจะใช้ก็กดเปิด" —
 *   เปิดในคณิตครั้งเดียวแล้วคณิตเปิดเองตลอด ส่วนไทย/สังคมยังปิดอยู่
 *   ค่าเริ่มต้นคือ **ปิดทุกวิชา** ทั้งโหมดฝึกและโหมดสอบ ไม่มีข้อยกเว้น
 *
 * ⚠️ PDPA (03 §1.6.1) — เก็บแค่ค่า boolean ต่อรหัสวิชา ไม่มีชื่อเด็ก ไม่มี id ผู้เรียน
 *   เป็นความชอบของ "อุปกรณ์" ไม่ใช่ข้อมูลการเรียน จึงไม่ต้องขึ้นเซิร์ฟเวอร์
 *
 * ⚠️ โหมดส่วนตัวของ Safari โยน error ตอนแตะ localStorage — ทั้งอ่านและเขียนจึงต้องมี
 *   try/catch · อ่านไม่ได้ = ใช้ค่าเริ่มต้น (ปิด) · เขียนไม่ได้ = แค่ไม่จำ ไม่ใช่เหตุให้แอปพัง
 *   (แบบเดียวกับ `rememberedOrgCode` ใน lib/session.ts)
 */
const KEY = (code: string | null): string => `tewtorp.pad.${code ?? "default"}`;

export function readPadOpen(code: string | null): boolean {
  try {
    return localStorage.getItem(KEY(code)) === "1";
  } catch {
    return false;
  }
}

export function writePadOpen(code: string | null, open: boolean): void {
  try {
    localStorage.setItem(KEY(code), open ? "1" : "0");
  } catch {
    // จำไม่ได้ก็แค่ต้องกดเปิดใหม่ครั้งหน้า
  }
}
